// Constants for filter types
export const FILTER_TYPES = {
  SEARCH: 'searchText',
  SEARCH_SCOPE: 'searchScope',
  FULFILLMENT_CHANNEL: 'selectedFulfillmentChannel',
  STATUS: 'selectedStatus',
  SELLER_ACCOUNT: 'selectedSellerAccount',
  COMPOUND_FILTERS: 'compoundFilters',
  SORT_BY: 'sortBy',
  SORT_ORDER: 'sortOrder',
  SORT_DAYS: 'sortDays',
  GROUP_SORT_BY: 'groupSortBy',
  GROUP_SORT_ORDER: 'groupSortOrder',
  GROUP_SORT_DAYS: 'groupSortDays',
  SALES_PERIOD: 'salesPeriod'
};

// Default filter values
export const DEFAULT_FILTER_VALUES = {
  [FILTER_TYPES.SEARCH]: '',
  [FILTER_TYPES.SEARCH_SCOPE]: 'all',
  [FILTER_TYPES.FULFILLMENT_CHANNEL]: 'all',
  [FILTER_TYPES.STATUS]: 'all',
  [FILTER_TYPES.SELLER_ACCOUNT]: 'all',
  [FILTER_TYPES.COMPOUND_FILTERS]: [],
  [FILTER_TYPES.SORT_BY]: null,
  [FILTER_TYPES.SORT_ORDER]: null,
  [FILTER_TYPES.SORT_DAYS]: null,
  [FILTER_TYPES.GROUP_SORT_BY]: null,
  [FILTER_TYPES.GROUP_SORT_ORDER]: null,
  [FILTER_TYPES.GROUP_SORT_DAYS]: null,
  [FILTER_TYPES.SALES_PERIOD]: 30
};

const SORT_FILTER_KEYS = new Set([
  FILTER_TYPES.SORT_BY,
  FILTER_TYPES.SORT_ORDER,
  FILTER_TYPES.SORT_DAYS,
  FILTER_TYPES.GROUP_SORT_BY,
  FILTER_TYPES.GROUP_SORT_ORDER,
  FILTER_TYPES.GROUP_SORT_DAYS
]);

// Validate filter type
export const isValidFilterType = (filterType) => {
  return Object.values(FILTER_TYPES).includes(filterType);
};

// Filter utilities
export const FilterManager = {
  getDefaultFilters: () => ({ ...DEFAULT_FILTER_VALUES }),
  
  isFilterActive: (value, defaultValue) => {
    // Handle selectedSellerAccount special case
    if (defaultValue === 'all' && Array.isArray(value)) {
      return value.length > 0;
    }
    
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    return value && value !== defaultValue;
  },
  
  getActiveFiltersCount: (filters) => {
    let count = 0;
    
    Object.keys(DEFAULT_FILTER_VALUES).forEach(key => {
      if (SORT_FILTER_KEYS.has(key)) return;
      if (FilterManager.isFilterActive(filters[key], DEFAULT_FILTER_VALUES[key])) {
        count++;
      }
    });
    
    return count;
  },
  
  hasChanges: (localFilters, appliedFilters) => {
    return Object.keys(DEFAULT_FILTER_VALUES).some(key => {
      const local = localFilters[key];
      const applied = appliedFilters[key];
      
      // Special handling for selectedSellerAccount (array vs string)
      if (key === 'selectedSellerAccount') {
        const localNormalized = Array.isArray(local) ? local : (local === 'all' ? [] : [local]);
        const appliedNormalized = Array.isArray(applied) ? applied : (applied === 'all' ? [] : [applied]);
        return JSON.stringify(localNormalized.sort()) !== JSON.stringify(appliedNormalized.sort());
      }

      if (key === 'compoundFilters') {
        return JSON.stringify(local || []) !== JSON.stringify(applied || []);
      }
      
      if (Array.isArray(local) && Array.isArray(applied)) {
        return JSON.stringify(local.sort()) !== JSON.stringify(applied.sort());
      }
      
      return local !== applied;
    });
  }
};
